module.exports = __webpack_public_path__ + "static/media/ascent.9306a4d6.png";